import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { BoqDistrictWiseModel } from 'src/app/models/department-reports.model';
import { ReportsService } from 'src/app/services/reports.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Router } from '@angular/router';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-boq-district-wise-report',
  templateUrl: './boq-district-wise-report.component.html',
  styleUrls: ['./boq-district-wise-report.component.scss']
})
export class BoqDistrictWiseReportComponent implements OnInit {
  value:any;
  districtWise: any[];
  grandTotalApp:number;
  grandVerfApp:number;
  grandBoqAmount:number;
  grandMiArea:number;
  appVerificationItems: MenuItem[];
  appVerificationModel: BoqDistrictWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  drilldownDetails:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;

  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "District_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "District_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getBoq_DistrictWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'BOQ Report (District Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.districtWise = data;
              this.appVerificationModel = data;
              this.calculateGrandTotal();
             
            }
            else{
              this.districtWise = [];
              this.appVerificationModel = [];
              this.calculateGrandTotal();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'BOQ Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "District" : d.District,
          "Total Application": d.TotalApplication,
          "Verified Application": d.VerifiedApplication,
          "BOQ Amount": d.BOQAmount,
          "Mi Area":d.Mi_Area,

        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      ); 
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      { field: 'BOQAmount', header: 'BOQ Amount' },
      { field: 'Mi_Area', header: 'Mi Area' },

    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  calculateGrandTotal(){
    this.grandTotalApp=0;
    this.grandVerfApp=0;
    this.grandBoqAmount=0;
    this.grandMiArea=0;
    for(let districtWiseData of this.districtWise) {
      this.grandTotalApp += districtWiseData.TotalApplication;
      this.grandVerfApp += districtWiseData.VerifiedApplication;
      this.grandBoqAmount += districtWiseData.BOQAmount;
      this.grandMiArea += districtWiseData.Mi_Area;
  }
  }
  showMaximizableDialog(value:any,status:any) {
      
      
    this.value=value;
    this.drilldownDetails={
      actionType:"BOQ",
      
      filterType:"District",
      value:this.value,
      status:status,
      MIType:""
    }
    
    this.displayMaximizable = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")

}
showMaximizableDialog_totalApp(value:any) {
      
      
  this.value=value;
  this.drilldownDetails={
    actionType:"BOQ",
    
    filterType:"District",
    value:this.value,
    MIType:""
  }
  
  this.displayMaximizable_totalApp = true;

  // console.log(this.value,"value")
  // console.log(this.drilldownDetails,"this.drilldownDetails")

}

}
